// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import {
//   ResponsiveContainer,
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Cell,
//   LineChart,
//   Line,
//   Legend,
// } from "recharts";
// import { useNavigate } from "react-router-dom";
// import "./Trends.css";

// const API_URL = process.env.REACT_APP_API_DJANGO_URL;

// const Trends = () => {
//   const [rangeType, setRangeType] = useState("weekly");
//   const [chartData, setChartData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [sites, setSites] = useState([]);
//   const [devices, setDevices] = useState([]);

//   const [selectedSite, setSelectedSite] = useState("");
//   const [selectedDevice, setSelectedDevice] = useState("");

//   const [pressureData, setPressureData] = useState([]);
//   const [deviceName, setDeviceName] = useState("");
//   const [alarmLoading, setAlarmLoading] = useState(false);
//   const [pressureLoading, setPressureLoading] = useState(false);

//   const [customers, setCustomers] = useState([]);
//   const role = localStorage.getItem("role");
//   const isSA = role === "SA";

//   const [selectedCustomer, setSelectedCustomer] = useState(
//     isSA ? "" : localStorage.getItem("customer_id")
//   );
//   const [healthData, setHealthData] = useState([]);
//   const [healthLoading, setHealthLoading] = useState(false);


//   const navigate = useNavigate();
//   // -------------------------
//   // TOP ALARM SITES
//   // -------------------------
//   const fetchTopAlarmSites = async (range) => {
//     try {
//       setAlarmLoading(true);

//       const token = localStorage.getItem("accessToken");

//       const response = await axios.get(
//         `${API_URL}/api/top_alarm_sites/?rangeType=${range}`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       setChartData(response.data.data || []);
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setAlarmLoading(false);
//     }
//   };



//   const fetchCustomers = async () => {
//     try {
//       const token = localStorage.getItem("accessToken");

//       const response = await axios.get(
//         `${API_URL}/api/get_customers/`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       const customerData = response.data || [];

//       setCustomers(customerData);

//       if (customerData.length > 0) {
//         setSelectedCustomer(customerData[0].tb_customer_id);
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   };
//   // -------------------------
//   // FETCH SITES
//   // -------------------------
//   // const fetchSites = async () => {
//   //   try {
//   //     if (!selectedCustomer) return;
//   //     const token = localStorage.getItem("accessToken");
//   //     // const customerId = localStorage.getItem("customer_id");
//   //     const customerId = selectedCustomer;

//   //     const response = await axios.get(
//   //       `${API_URL}/api/get_customer_sites/${customerId}/`,
//   //       {
//   //         headers: {
//   //           Authorization: `Bearer ${token}`,
//   //           Accept: "application/json",
//   //           "Content-Type": "application/json",
//   //         },
//   //         data: {},
//   //       }
//   //     );

//   //     const siteData = response.data.data || [];

//   //     setSites(siteData);

//   //     if (siteData.length > 0) {
//   //       setSelectedSite(siteData[0].asset_id);
//   //     }
//   //   } catch (err) {
//   //     console.error(err);
//   //   }
//   // };



//   const fetchSites = async () => {
//   try {
//     const token = localStorage.getItem("accessToken");
//     const role = localStorage.getItem("role");
//     const userId = localStorage.getItem("userId");

//     let siteData = [];

//     const config = {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         Accept: "application/json",
//         "Content-Type": "application/json",
//       },
//       data: {},
//     };

//     // =========================
//     // ✅ CUSTOMER ADMIN (CA)
//     // =========================
//     if (role === "CA") {
//       const customerId = localStorage.getItem("customer_id");

//       const response = await axios.get(
//         `${API_URL}/api/get_customer_sites/${customerId}/`,
//         config
//       );

//       siteData = response.data.data || [];
//     }

//     // =========================
//     // ✅ SUPER ADMIN (SA)
//     // =========================
//     else if (role === "SA") {
//       if (!selectedCustomer) return;

//       const response = await axios.get(
//         `${API_URL}/api/get_customer_sites/${selectedCustomer}/`,
//         config
//       );

//       siteData = response.data.data || [];
//     }

//     // =========================
//     // ✅ SITE ENGINEER (SE)
//     // =========================
//     else if (role === "SE") {
//       const response = await axios.get(
//         `${API_URL}/api/engineer_sites/${userId}/`,
//         config
//       );

//       siteData = (response.data.sites || []).map((s) => ({
//         asset_id: s.asset_id,
//         name: s.site_name,
//       }));
//     }

//     // =========================
//     // ✅ SUPERVISOR (S)
//     // =========================
//     else if (role === "S") {
//       const response = await axios.get(
//         `${API_URL}/api/supervisor_sites/${userId}/`,
//         config
//       );

//       siteData = (response.data.sites || []).map((s) => ({
//         asset_id: s.asset_id,
//         name: s.name,
//       }));
//     }

//     setSites(siteData);

//     if (siteData.length > 0) {
//       setSelectedSite(siteData[0].asset_id);
//     } else {
//       setSelectedSite("");
//     }
//   } catch (err) {
//     console.error("Error fetching sites:", err);
//   }
// };

//   // -------------------------
//   // LOAD INITIAL DATA
//   // -------------------------
//   useEffect(() => {
//     fetchTopAlarmSites(rangeType);
//   }, [rangeType]);

//   // useEffect(() => {
//   //   fetchCustomers();
//   // }, []);

//   useEffect(() => {
//     if (isSA) fetchCustomers();
//   }, []);

//   useEffect(() => {
//     if (selectedCustomer) {
//       fetchSites();
//     }
//   }, [selectedCustomer]);
//   // -------------------------
//   // FETCH DEVICES
//   // -------------------------
//   useEffect(() => {
//     if (!selectedSite) return;

//     const fetchDevices = async () => {
//       try {
//         const token = localStorage.getItem("accessToken");

//         const response = await axios.get(
//           `${API_URL}/api/site_devices/${selectedSite}/`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );

//         const deviceList = response.data.devices || [];

//         setDevices(deviceList);

//         if (deviceList.length > 0) {
//           setSelectedDevice(deviceList[0].device_id);
//           setDeviceName(deviceList[0].device_name);
//         }
//       } catch (err) {
//         console.error(err);
//       }
//     };

//     fetchDevices();
//   }, [selectedSite]);

//   // -------------------------
//   // DEVICE CHANGE
//   // -------------------------
//   const handleDeviceChange = (e) => {
//     const deviceId = e.target.value;

//     setSelectedDevice(deviceId);

//     const selected = devices.find(
//       (d) => d.device_id === deviceId
//     );

//     setDeviceName(selected?.device_name || "");
//   };

//   // -------------------------
//   // FETCH PRESSURE TREND
//   // -------------------------
//   const fetchPressureTrend = async () => {
//     try {
//       setPressureLoading(true);

//       const token = localStorage.getItem("accessToken");

//       const response = await axios.get(
//         `${API_URL}/api/pressure_trends/${selectedDevice}/`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       setPressureData(response.data.data || []);
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setPressureLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (!selectedDevice) return;

//     fetchPressureTrend();
//   }, [selectedDevice]);


//   // -------------------------
//   // TOOLTIP
//   // -------------------------
//   const PressureTooltip = ({
//     active,
//     payload,
//     label,
//   }) => {
//     if (active && payload && payload.length) {
//       return (
//         <div className="custom-tooltip">
//           <p>
//             <strong>Device:</strong> {deviceName}
//           </p>

//           <p>
//             <strong>Time:</strong> {label}
//           </p>

//           {payload.map((entry, index) => (
//             <p key={index}>
//               <strong>{entry.name}</strong> :
//               {" "}
//               {entry.value}
//             </p>
//           ))}
//         </div>
//       );
//     }

//     return null;
//   };


//   // SITE HEALTH STATUS TRENDS //

//   const fetchHealthTrend = async () => {
//     try {
//       setHealthLoading(true);

//       const token = localStorage.getItem("accessToken");

//       const response = await axios.get(
//         `${API_URL}/api/supply-health-trend/${selectedDevice}/`,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       // const chartData = (response.data.data || []).map(
//       //   (item) => ({
//       //     time: new Date(item.timestamp).toLocaleTimeString(
//       //       [],
//       //       {
//       //         hour: "2-digit",
//       //         minute: "2-digit",
//       //       }
//       //     ),
//       //     supply_health: item.supply_health,
//       //   })
//       // );

//       const chartData = (response.data.data || []).map(
//         (item) => ({
//           time: item.time,
//           supply_health: item.supply_health,
//         })
//       );
//       setHealthData(chartData);
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setHealthLoading(false);
//     }
//   };


//   useEffect(() => {
//     if (!selectedDevice) return;

//     fetchHealthTrend();
//   }, [selectedDevice]);

//   useEffect(() => {
//     if (!selectedDevice) return;

//     const interval = setInterval(() => {
//       fetchPressureTrend();
//       fetchHealthTrend();
//     }, 180000); // 3 minutes

//     return () => clearInterval(interval);
//   }, [selectedDevice]);

//   return (
//     <div className="trends-container">

//       <div style={{ marginBottom: "15px" }}>
//         <button
//           onClick={() => navigate("/dashboard")}
//           className="back-btn"
//         >
//           ← Back
//         </button>
//       </div>

//       {/* ========================= */}
//       {/* TOP ALARM BAR CHART */}
//       {/* ========================= */}

//       <div className="trends-header">
//         <h2>Top Alarm Sites</h2>

//         <select
//           className="trend-dropdown"
//           value={rangeType}
//           onChange={(e) =>
//             setRangeType(e.target.value)
//           }
//         >
//           <option value="daily">Daily</option>
//           <option value="weekly">Weekly</option>
//           <option value="monthly">Monthly</option>
//         </select>
//       </div>

//       <div className="chart-card">
//         {alarmLoading ? (
//           <div className="chart-loader">
//             Loading alarm trends...
//           </div>
//         ) : (
//           <ResponsiveContainer width="100%" height={400}>
//             <BarChart data={chartData}>
//               <CartesianGrid strokeDasharray="3 3" />

//               <XAxis dataKey="site_name" />

//               <YAxis />

//               <Tooltip />

//               <Bar
//                 dataKey="alarm_count"
//                 radius={[8, 8, 0, 0]}
//               >
//                 {chartData.map((entry, index) => (
//                   <Cell
//                     key={index}
//                     fill={
//                       index === 0
//                         ? "#ef4444"
//                         : index === 1
//                           ? "#f97316"
//                           : index === 2
//                             ? "#eab308"
//                             : "#3b82f6"
//                     }
//                   />
//                 ))}
//               </Bar>
//             </BarChart>
//           </ResponsiveContainer>
//         )}
//       </div>

//       {/* ========================= */}
//       {/* PRESSURE TREND CHART */}
//       {/* ========================= */}

//       <div
//         className="chart-card"
//         style={{ marginTop: "30px" }}
//       >
//         <div className="dropdown-row">

//           {/* <select
//             className="trend-dropdown"
//             value={selectedCustomer}
//             onChange={(e) => setSelectedCustomer(e.target.value)}
//           >
//             {customers.map((customer) => (
//               <option
//                 key={customer.tb_customer_id}
//                 value={customer.tb_customer_id}
//               >
//                 {customer.customer_name}
//               </option>
//             ))}
//           </select> */}

//           {isSA && (
//             <select
//               className="trend-dropdown"
//               value={selectedCustomer}
//               onChange={(e) => setSelectedCustomer(e.target.value)}
//             >
//                  <option value="" disabled>Select Customer</option>

//               {customers.map((customer) => (
//                 <option
//                   key={customer.tb_customer_id}
//                   value={customer.tb_customer_id}
//                 >
//                   {customer.customer_name}
//                 </option>
//               ))}
//             </select>
//           )}

//           <select
//             className="trend-dropdown"
//             value={selectedSite}
//             onChange={(e) =>
//               setSelectedSite(e.target.value)
//             }
//           >
//             <option value="" disabled>Select Site</option>

//             {sites.map((site) => (
//               <option
//                 key={site.asset_id}
//                 value={site.asset_id}
//               >
//                 {site.name}
//               </option>
//             ))}
//           </select>

//           <select
//             className="trend-dropdown"
//             value={selectedDevice}
//             onChange={handleDeviceChange}
//           >
//             <option value="" disabled>Select Device</option>

//             {devices.map((device) => (
//               <option
//                 key={device.device_id}
//                 value={device.device_id}
//               >
//                 {device.device_name}
//               </option>
//             ))}
//           </select>
//         </div>

//         <h2 className="pressure-title">
//           Pressure Trend - {deviceName}
//         </h2>
//         {pressureLoading ? (
//           <div className="chart-loader">
//             Loading pressure trends...
//           </div>
//         ) : (
//           <ResponsiveContainer
//             width="100%"
//             height={400}
//           >
//             <LineChart data={pressureData}>
//               <CartesianGrid strokeDasharray="3 3" />

//               <XAxis
//                 dataKey="time"
//                 label={{
//                   value: "Hours",
//                   // value: "Time (10 Min)",
//                   position: "insideBottom",
//                   offset: -5,
//                 }}
//               />

//               <YAxis
//                 label={{
//                   value: "Value",
//                   angle: -90,
//                   position: "insideLeft",
//                 }}
//               />

//               <Tooltip content={<PressureTooltip />} />

//               <Legend />

//               <Line
//                 type="monotone"
//                 dataKey="lower_hydrant_pressure"
//                 stroke="#ef4444"
//                 strokeWidth={3}
//                 name="Lower Hydrant Pressure"
//               />

//               <Line
//                 type="monotone"
//                 dataKey="lower_sprinkler_pressure"
//                 stroke="#3b82f6"
//                 strokeWidth={3}
//                 name="Lower Sprinkler Pressure"
//               />

//               <Line
//                 type="monotone"
//                 dataKey="water_tank_level"
//                 stroke="#10b981"
//                 strokeWidth={3}
//                 name="Water Tank"
//               />

//               <Line
//                 type="monotone"
//                 dataKey="diesel_tank_level"
//                 stroke="#f59e0b"
//                 strokeWidth={3}
//                 name="Diesel Tank"
//               />
//             </LineChart>
//           </ResponsiveContainer>
//         )}
//       </div>


//       <div
//         className="chart-card"
//         style={{ marginTop: "30px" }}
//       >
//         <h2 className="pressure-title">
//           System Health Trend - {deviceName}
//         </h2>

//         {healthLoading ? (
//           <div className="chart-loader">
//             Loading system health...
//           </div>
//         ) : (
//           <>
//             <div className="health-timeline">
//               {healthData.map((item, index) => (
//                 <div
//                   key={index}
//                   className={`health-block ${item.supply_health === 1
//                     ? "healthy"
//                     : "fault"
//                     }`}
//                   title={`${item.time} - ${item.supply_health === 1
//                     ? "Healthy"
//                     : "Fault"
//                     }`}
//                 >
//                   <span className="health-time">
//                     {item.time}
//                   </span>
//                 </div>
//               ))}
//             </div>

//             <div className="health-legend">
//               <div className="legend-item">
//                 <span className="legend-color healthy"></span>
//                 Healthy
//               </div>

//               <div className="legend-item">
//                 <span className="legend-color fault"></span>
//                 Fault
//               </div>
//             </div>
//           </>
//         )}
//       </div>

//     </div>
//   );
// };

// export default Trends;

















import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
  LineChart,
  Line,
  Legend,
} from "recharts";
import { useNavigate } from "react-router-dom";
import "./Trends.css";

const API_URL = process.env.REACT_APP_API_DJANGO_URL;

const Trends = () => {
  const [rangeType, setRangeType] = useState("weekly");
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [sites, setSites] = useState([]);
  const [devices, setDevices] = useState([]);

  const [selectedSite, setSelectedSite] = useState("");
  const [selectedDevice, setSelectedDevice] = useState("");

  const [pressureData, setPressureData] = useState([]);
  const [deviceName, setDeviceName] = useState("");
  const [alarmLoading, setAlarmLoading] = useState(false);
  const [pressureLoading, setPressureLoading] = useState(false);

  const [customers, setCustomers] = useState([]);
  const role = localStorage.getItem("role");
  const isSA = role === "SA";

  const [selectedCustomer, setSelectedCustomer] = useState(
    isSA ? "" : localStorage.getItem("customer_id")
  );
  const [healthData, setHealthData] = useState([]);
  const [healthLoading, setHealthLoading] = useState(false);
  const [healthSummary, setHealthSummary] = useState(null);


  const navigate = useNavigate();
  // -------------------------
  // TOP ALARM SITES
  // -------------------------
  const fetchTopAlarmSites = async (range) => {
    try {
      setAlarmLoading(true);

      const token = localStorage.getItem("accessToken");

      const response = await axios.get(
        `${API_URL}/api/top_alarm_sites/?rangeType=${range}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setChartData(response.data.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setAlarmLoading(false);
    }
  };



  const fetchCustomers = async () => {
    try {
      const token = localStorage.getItem("accessToken");

      const response = await axios.get(
        `${API_URL}/api/get_customers/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const customerData = response.data || [];

      setCustomers(customerData);

      if (customerData.length > 0) {
        setSelectedCustomer(customerData[0].tb_customer_id);
      }
    } catch (err) {
      console.error(err);
    }
  };
  // -------------------------
  // FETCH SITES
  // -------------------------
  // const fetchSites = async () => {
  //   try {
  //     if (!selectedCustomer) return;
  //     const token = localStorage.getItem("accessToken");
  //     // const customerId = localStorage.getItem("customer_id");
  //     const customerId = selectedCustomer;

  //     const response = await axios.get(
  //       `${API_URL}/api/get_customer_sites/${customerId}/`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           Accept: "application/json",
  //           "Content-Type": "application/json",
  //         },
  //         data: {},
  //       }
  //     );

  //     const siteData = response.data.data || [];

  //     setSites(siteData);

  //     if (siteData.length > 0) {
  //       setSelectedSite(siteData[0].asset_id);
  //     }
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };



  const fetchSites = async () => {
  try {
    const token = localStorage.getItem("accessToken");
    const role = localStorage.getItem("role");
    const userId = localStorage.getItem("userId");

    let siteData = [];

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: {},
    };

    // =========================
    // ✅ CUSTOMER ADMIN (CA)
    // =========================
    if (role === "CA" || role === "DC") {
      const customerId = localStorage.getItem("customer_id");

      const response = await axios.get(
        `${API_URL}/api/get_customer_sites/${customerId}/`,
        config
      );

      siteData = response.data.data || [];
    }

    // =========================
    // ✅ SUPER ADMIN (SA)
    // =========================
    else if (role === "SA") {
      if (!selectedCustomer) return;

      const response = await axios.get(
        `${API_URL}/api/get_customer_sites/${selectedCustomer}/`,
        config
      );

      siteData = response.data.data || [];
    }

    // =========================
    // ✅ SITE ENGINEER (SE)
    // =========================
    else if (role === "SE") {
      const response = await axios.get(
        `${API_URL}/api/engineer_sites/${userId}/`,
        config
      );

      siteData = (response.data.sites || []).map((s) => ({
        asset_id: s.asset_id,
        name: s.site_name,
      }));
    }

    // =========================
    // ✅ SUPERVISOR (S)
    // =========================
    else if (role === "S") {
      const response = await axios.get(
        `${API_URL}/api/supervisor_sites/${userId}/`,
        config
      );

      siteData = (response.data.sites || []).map((s) => ({
        asset_id: s.asset_id,
        name: s.name,
      }));
    }

    setSites(siteData);

    if (siteData.length > 0) {
      setSelectedSite(siteData[0].asset_id);
    } else {
      setSelectedSite("");
    }
  } catch (err) {
    console.error("Error fetching sites:", err);
  }
};

  // -------------------------
  // LOAD INITIAL DATA
  // -------------------------
  useEffect(() => {
    fetchTopAlarmSites(rangeType);
  }, [rangeType]);

  // useEffect(() => {
  //   fetchCustomers();
  // }, []);

  useEffect(() => {
    if (isSA) fetchCustomers();
  }, []);

  useEffect(() => {
    if (selectedCustomer) {
      fetchSites();
    }
  }, [selectedCustomer]);
  // -------------------------
  // FETCH DEVICES
  // -------------------------
  useEffect(() => {
    if (!selectedSite) return;

    const fetchDevices = async () => {
      try {
        const token = localStorage.getItem("accessToken");

        const response = await axios.get(
          `${API_URL}/api/site_devices/${selectedSite}/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const deviceList = response.data.devices || [];

        setDevices(deviceList);

        if (deviceList.length > 0) {
          setSelectedDevice(deviceList[0].device_id);
          setDeviceName(deviceList[0].device_name);
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchDevices();
  }, [selectedSite]);

  // -------------------------
  // DEVICE CHANGE
  // -------------------------
  const handleDeviceChange = (e) => {
    const deviceId = e.target.value;

    setSelectedDevice(deviceId);

    const selected = devices.find(
      (d) => d.device_id === deviceId
    );

    setDeviceName(selected?.device_name || "");
  };

  // -------------------------
  // FETCH PRESSURE TREND
  // -------------------------
  const fetchPressureTrend = async () => {
    try {
      setPressureLoading(true);

      const token = localStorage.getItem("accessToken");

      const response = await axios.get(
        `${API_URL}/api/pressure_trends/${selectedDevice}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setPressureData(response.data.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setPressureLoading(false);
    }
  };

  useEffect(() => {
    if (!selectedDevice) return;

    fetchPressureTrend();
  }, [selectedDevice]);


  // -------------------------
  // TOOLTIP
  // -------------------------
  const PressureTooltip = ({
    active,
    payload,
    label,
  }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p>
            <strong>Device:</strong> {deviceName}
          </p>

          <p>
            <strong>Time:</strong> {label}
          </p>

          {payload.map((entry, index) => (
            <p key={index}>
              <strong>{entry.name}</strong> :
              {" "}
              {entry.value}
            </p>
          ))}
        </div>
      );
    }

    return null;
  };


  // SITE HEALTH STATUS TRENDS //

  // const fetchHealthTrend = async () => {
  //   try {
  //     setHealthLoading(true);

  //     const token = localStorage.getItem("accessToken");

  //     const response = await axios.get(
  //       `${API_URL}/api/supply-health-trend/${selectedDevice}/`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     // const chartData = (response.data.data || []).map(
  //     //   (item) => ({
  //     //     time: new Date(item.timestamp).toLocaleTimeString(
  //     //       [],
  //     //       {
  //     //         hour: "2-digit",
  //     //         minute: "2-digit",
  //     //       }
  //     //     ),
  //     //     supply_health: item.supply_health,
  //     //   })
  //     // );

  //     const chartData = (response.data.data || []).map(
  //       (item) => ({
  //         time: item.time,
  //         supply_health: item.supply_health,
  //       })
  //     );
  //     setHealthData(chartData);
  //   } catch (err) {
  //     console.error(err);
  //   } finally {
  //     setHealthLoading(false);
  //   }
  // };


  const fetchHealthTrend = async () => {
  try {
    setHealthLoading(true);

    const token = localStorage.getItem("accessToken");

    const response = await axios.get(
      `${API_URL}/api/supply-health-trend/${selectedDevice}/`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setHealthData(response.data.data || []);
    setHealthSummary(response.data.summary || null);
  } catch (err) {
    console.error(err);
  } finally {
    setHealthLoading(false);
  }
};




  useEffect(() => {
    if (!selectedDevice) return;

    fetchHealthTrend();
  }, [selectedDevice]);

  useEffect(() => {
    if (!selectedDevice) return;

    const interval = setInterval(() => {
      fetchPressureTrend();
      fetchHealthTrend();
    }, 180000); // 3 minutes

    return () => clearInterval(interval);
  }, [selectedDevice]);

  return (
    <div className="trends-container">

      <div style={{ marginBottom: "15px" }}>
        <button
          onClick={() => navigate("/dashboard")}
          className="back-btn"
        >
          ← Back
        </button>
      </div>

      {/* ========================= */}
      {/* TOP ALARM BAR CHART */}
      {/* ========================= */}

      <div className="trends-header">
        <h2>Top Alarm Sites</h2>

        <select
          className="trend-dropdown"
          value={rangeType}
          onChange={(e) =>
            setRangeType(e.target.value)
          }
        >
          <option value="daily">Daily</option>
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
        </select>
      </div>

      <div className="chart-card">
        {alarmLoading ? (
          <div className="chart-loader">
            Loading alarm trends...
          </div>
        ) : (
          <ResponsiveContainer width="100%" height={400}>
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />

              <XAxis dataKey="site_name" />

              <YAxis />

              <Tooltip />

              <Bar
                dataKey="alarm_count"
                radius={[8, 8, 0, 0]}
              >
                {chartData.map((entry, index) => (
                  <Cell
                    key={index}
                    fill={
                      index === 0
                        ? "#ef4444"
                        : index === 1
                          ? "#f97316"
                          : index === 2
                            ? "#eab308"
                            : "#3b82f6"
                    }
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>

      {/* ========================= */}
      {/* PRESSURE TREND CHART */}
      {/* ========================= */}

      <div
        className="chart-card"
        style={{ marginTop: "30px" }}
      >
        <div className="dropdown-row">

          {/* <select
            className="trend-dropdown"
            value={selectedCustomer}
            onChange={(e) => setSelectedCustomer(e.target.value)}
          >
            {customers.map((customer) => (
              <option
                key={customer.tb_customer_id}
                value={customer.tb_customer_id}
              >
                {customer.customer_name}
              </option>
            ))}
          </select> */}

          {isSA && (
            <select
              className="trend-dropdown"
              value={selectedCustomer}
              onChange={(e) => setSelectedCustomer(e.target.value)}
            >
                 <option value="" disabled>Select Customer</option>

              {customers.map((customer) => (
                <option
                  key={customer.tb_customer_id}
                  value={customer.tb_customer_id}
                >
                  {customer.customer_name}
                </option>
              ))}
            </select>
          )}

          <select
            className="trend-dropdown"
            value={selectedSite}
            onChange={(e) =>
              setSelectedSite(e.target.value)
            }
          >
            <option value="" disabled>Select Site</option>

            {sites.map((site) => (
              <option
                key={site.asset_id}
                value={site.asset_id}
              >
                {site.name}
              </option>
            ))}
          </select>

          <select
            className="trend-dropdown"
            value={selectedDevice}
            onChange={handleDeviceChange}
          >
            <option value="" disabled>Select Device</option>

            {devices.map((device) => (
              <option
                key={device.device_id}
                value={device.device_id}
              >
                {device.device_name}
              </option>
            ))}
          </select>
        </div>

        <h2 className="pressure-title">
          Pressure Trend (Last 1 Hr) - {deviceName}
        </h2>
        {pressureLoading ? (
          <div className="chart-loader">
            Loading pressure trends...
          </div>
        ) : (
          <ResponsiveContainer
            width="100%"
            height={400}
          >
            <LineChart data={pressureData}>
              <CartesianGrid strokeDasharray="3 3" />

              <XAxis
                dataKey="time"
                label={{
                  value: "Hours",
                  // value: "Time (10 Min)",
                  position: "insideBottom",
                  offset: -5,
                }}
              />

              <YAxis
                label={{
                  value: "Value",
                  angle: -90,
                  position: "insideLeft",
                }}
              />

              <Tooltip content={<PressureTooltip />} />

              <Legend />

              <Line
                type="monotone"
                dataKey="lower_hydrant_pressure"
                stroke="#ef4444"
                strokeWidth={3}
                name="Lower Hydrant Pressure"
              />

              <Line
                type="monotone"
                dataKey="lower_sprinkler_pressure"
                stroke="#3b82f6"
                strokeWidth={3}
                name="Lower Sprinkler Pressure"
              />

              <Line
                type="monotone"
                dataKey="water_tank_level"
                stroke="#10b981"
                strokeWidth={3}
                name="Water Tank"
              />

              <Line
                type="monotone"
                dataKey="diesel_tank_level"
                stroke="#f59e0b"
                strokeWidth={3}
                name="Diesel Tank"
              />
            </LineChart>
          </ResponsiveContainer>
        )}
      </div>


      {/* <div
        className="chart-card"
        style={{ marginTop: "30px" }}
      >
        <h2 className="pressure-title">
          System Health State Change Trend - {deviceName}
        </h2>

        {healthLoading ? (
          <div className="chart-loader">
            Loading system health...
          </div>
        ) : (
          <>
            <div className="health-timeline">
              {healthData.map((item, index) => (
                <div
                  key={index}
                  className={`health-block ${item.supply_health === 1
                    ? "healthy"
                    : "fault"
                    }`}
                  title={`${item.time} - ${item.supply_health === 1
                    ? "Healthy"
                    : "Fault"
                    }`}
                >
                  <span className="health-time">
                    {item.time}
                  </span>
                </div>
              ))}
            </div>

            <div className="health-legend">
              <div className="legend-item">
                <span className="legend-color healthy"></span>
                Healthy
              </div>

              <div className="legend-item">
                <span className="legend-color fault"></span>
                Fault
              </div>
            </div>
          </>
        )}
      </div> */}
      <div className="chart-card" style={{ marginTop: "30px" }}>
  <h2 className="pressure-title">
    System Health State Change(Last 3 Hrs) - {deviceName}
  </h2>

  {healthLoading ? (
    <div className="chart-loader">Loading system health...</div>
  ) : healthData.length === 0 ? (
    <div className="chart-loader">No health data in the last 3 hours</div>
  ) : (
    <>
      {/* ---------- Summary cards ---------- */}
      {healthSummary && (
        <div className="health-summary">
          <div className={`summary-card now-${healthSummary.current_status === "Healthy" ? "ok" : "bad"}`}>
            <span>Current</span>
            <strong>{healthSummary.current_status}</strong>
          </div>
          <div className="summary-card">
            <span>Healthy periods</span>
            <strong>{healthSummary.healthy_count}</strong>
            <small>{healthSummary.healthy_minutes} min total</small>
          </div>
          <div className="summary-card">
            <span>Fault periods</span>
            <strong>{healthSummary.fault_count}</strong>
            <small>{healthSummary.fault_minutes} min total</small>
          </div>
          <div className="summary-card">
            <span>State changes</span>
            <strong>{healthSummary.state_changes}</strong>
          </div>
        </div>
      )}

      {/* ---------- Timeline bar (width = duration) ---------- */}
      <div className="health-bar">
        {healthData.map((seg) => {
          const total = healthData.reduce((s, x) => s + x.duration_minutes, 0) || 1;
          const width = Math.max((seg.duration_minutes / total) * 100, 1.5);

          return (
            <div
              key={seg.sr_no}
              className={`health-seg ${seg.status === "Healthy" ? "seg-healthy" : "seg-fault"}`}
              style={{ width: `${width}%` }}
              title={`${seg.status}: ${seg.start_time} - ${seg.end_time} (${seg.duration})`}
            >
              {width > 8 && <span>{seg.duration}</span>}
            </div>
          );
        })}
      </div>
      <div className="health-axis">
        <span>{healthData[0].start_time}</span>
        <span>Now</span>
      </div>

      {/* ---------- Change log table ---------- */}
      <table className="health-table">
        <thead>
          <tr>
            <th>Sr.No</th>
            <th>Status</th>
            <th>From</th>
            <th>To</th>
            <th>Duration</th>
          </tr>
        </thead>
        <tbody>
          {[...healthData].reverse().map((seg,index) => (
            <tr key={seg.sr_no}>
             <td>{index + 1}</td>
              <td>
                <span className={`badge ${seg.status === "Healthy" ? "badge-ok" : "badge-bad"}`}>
                  {seg.status}
                </span>
              </td>
              <td>{seg.start_time}</td>
              <td>{seg.end_time}</td>
              <td>{seg.duration}{seg.ongoing ? " (running)" : ""}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="health-legend">
        <div className="legend-item"><span className="legend-color healthy"></span>Healthy</div>
        <div className="legend-item"><span className="legend-color fault"></span>Fault</div>
      </div>
    </>
  )}
</div>

    </div>
  );
};

export default Trends;